import { motion } from "framer-motion";
import { scrollToId } from "@/lib/lenis";

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-[#0B0B0C]/80 backdrop-blur-md"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <span className="font-display text-2xl tracking-wide text-white group-hover:text-[#CCFF00] transition-colors duration-300">
            JD<span className="text-[#CCFF00]">.</span>
          </span>
          <span className="hidden sm:block text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-mono2">
            Performance Coaching
          </span>
        </button>
        <button
          onClick={() => scrollToId("#apply")}
          data-testid="nav-apply-cta"
          className="bg-[#CCFF00] text-[#0B0B0C] text-xs font-bold uppercase tracking-[0.15em] px-5 py-2.5 hover:bg-white transition-colors duration-300"
        >
          Apply
        </button>
      </div>
    </motion.header>
  );
}
